import baseComponent from 'BASE/components/chat/chat.base.component.roomMessage'
import UTIL from 'BASE/common/chat/chat.util'

export default {
    mixins: [baseComponent],
    computed: {
        timestamp: function () {
            return UTIL.formatDate(this.prop_message.timestamp, "YYYY-MM-DD HH:mm:ss");
        },
    },
};
